import { Component, OnInit} from '@angular/core';
import { AccessService } from './access.service';
import { environment } from 'environments/environment';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(private accessService: AccessService) {}

  ngOnInit() {
    if(environment.hostname != environment.centralDomain){
    this.accessService.storeQueryParams();
    }
  }
}
